'use strict';

app.controller('NotificationCtrl', [
    '$rootScope',
    '$scope',
    '$http',
    '$timeout',
    'csLanguage',
    function($rootScope, $scope, $http, $timeout, csLanguage) {
        var NOTIFICATION_READED = 'readed';
        var NOTIFICATION_DELETED = 'deleted';

        var REFRESH_TIME_IN_MILISECONDS = 300000;

        var loading = false;
        $scope.loadTimeout = null;

        $scope.more = {
            on: true,
            first: false,
            last: false,
            load: loadMore,
        };

        $scope.notifications = {
            results: [],
            counts: {
                all: 0,
                unreaded: 0,
            },
        };

        $scope.search = '';

        $scope.searching = function(value) {
            if (!$scope.search) return true;

            const term = $scope.search.toLowerCase();
            const contentMatch = value.content.toLowerCase().includes(term);

            const createdAtFormatted = $scope.getLocalDateTime(value.createdAt).toLowerCase();
            const dateMatch = createdAtFormatted.includes(term);

            return contentMatch || dateMatch;
        };

        function loadMore(lastNotificationId) {
            $scope.more.on = false;

            var params = {
                last: lastNotificationId,
            };

            var endpoint = `/rest-api/ms/notification/api/notification?language=${csLanguage.get('lang')}`;

            return $http.get(endpoint, { params: params, displayButterbar: false }).then(
                function(response) {
                    $scope.more.on = true;

                    if (response.data === void 0) {
                        return false;
                    }

                    var data = response.data;

                    $scope.notifications.counts = data.counts;
                    $scope.notifications.results = $scope.notifications.results.concat(data.results);

                    if ($scope.notifications.results.length > 0) {
                        $scope.more.last = $scope.notifications.results[$scope.notifications.results.length - 1];
                    }

                    $scope.reloadNotificationCounter();
                    $scope.closePanelWhenEmpty();
                },
                function() {
                    $scope.more.on = true;
                }
            );
        }

        $scope.isReaded = function(notification) {
            return notification.status === NOTIFICATION_READED;
        };

        $scope.isDeleted = function(notification) {
            return notification.status === NOTIFICATION_DELETED;
        };

        $scope.getLocalDateTime = function(date) {
            var m = moment(date);

            return m.format('YYYY-MM-DD HH:mm');
        };

        $scope.reloadNotificationCounter = function() {
            $rootScope.$broadcast('reloadNotificationCounter', {
                counts: $scope.notifications.counts,
            });
        };

        $scope.getNotifications = function() {
            $scope.more.on = false;

            var params = {
                page: 1,
            };

            var endpoint = `/rest-api/ms/notification/api/notification?language=${csLanguage.get('lang')}`;

            return $http.get(endpoint, { params: params, displayButterbar: false }).then(
                function(response) {
                    $scope.more.on = true;

                    if (response.data === void 0) {
                        return false;
                    }

                    var data = response.data;

                    $scope.notifications.counts = data.counts;

                    if ($scope.notifications.results.length === 0) {
                        $scope.notifications = data;
                    }

                    if ($scope.notifications.results.length > 0) {
                        $scope.more.first = $scope.notifications.results[0];
                        $scope.more.last = $scope.notifications.results[$scope.notifications.results.length - 1];

                        var newest = data.results.filter((o) => o.id > $scope.more.first.id);

                        if (newest.length > 0) {
                            $scope.notifications.results = newest.concat($scope.notifications.results);
                        }
                    }

                    $scope.reloadNotificationCounter();
                    $scope.closePanelWhenEmpty();

                    $timeout.cancel($scope.loadTimeout);
                    $scope.loadTimeout = $timeout($scope.getNotifications, REFRESH_TIME_IN_MILISECONDS);
                },
                function() {
                    $scope.more.on = true;
                }
            );
        };

        $scope.readAll = function() {
            if (loading) {
                return false;
            }

            loading = true;

            var endpoint = '/rest-api/ms/notification/api/notification/read';

            return $http
                .post(endpoint)
                .then(
                    function() {
                        loading = false;
                    },
                    function() {
                        loading = false;
                    }
                )
                .then(function() {
                    $scope.getNotifications();
                });
        };

        $scope.update = function(notification) {
            if (loading) {
                return false;
            }

            loading = true;

            var id = notification.id;
            var endpoint = `/rest-api/ms/notification/api/notification/${id}/flag`;

            $http.put(endpoint, {}, { displayButterbar: false }).then(
                function(response) {
                    var data = response.data;

                    notification.status = data.status;

                    switch (notification.status) {
                        case NOTIFICATION_READED:
                            $scope.notifications.counts.unreaded--;
                            break;
                        case NOTIFICATION_DELETED:
                            $scope.notifications.counts.all--;
                            break;
                    }

                    $scope.reloadNotificationCounter();
                    $scope.closePanelWhenEmpty();

                    loading = false;
                },
                function() {
                    loading = false;
                }
            );
        };

        $scope.closePanelWhenEmpty = function() {
            if ($scope.notifications.counts.all === 0) {
                var $panel = $('.cd-panel.cd-panel--is-visible');

                if ($panel.length) {
                    $panel.removeClass('cd-panel--is-visible');
                }
            }
        };

        $scope.$on('$destroy', function() {
            $timeout.cancel($scope.loadTimeout);
        });

        $scope.init = function() {
            $scope.getNotifications();
        };

        $scope.init();
    },
]);
